import * as angular from "angular";
import * as _ from "lodash";
import {$accountFactory} from "../account/$account.factory";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {DeliveriesService} from "./services/deliveries-service.service";
import {OrdersService} from "../orders/services/orders-service.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {TaskModel} from "../tasks/models/task.model";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../commons/models/view-settings.model";
import {ServicesViewsStateType} from "./types/services-views-state.type";
import {DateRangeContextService} from "../commons/services/date-range-context.service";
import {ServicesFacadeService} from "./angular/services/services-facade.service";
import {takeWhile} from "rxjs";
import {Service} from "./models/service.model";
import {GroupModel} from "../groups/models/group.model";
import {BatchRequestsService} from "../batch/services/batch-requests.service";

angular
  .module('bringoz.admin.deliveries')
  .config(DeliveriesConfig);

/* @ngInject */
function DeliveriesConfig($stateProvider, moment) {
  $stateProvider

    //*** Deliveries View **//
    .state('deliveries', {
      parent: 'bringoz.site',
      abstract: true,
      controllerAs: 'vm',
      url: '/deliveries?:from&:to&:group&:serviceTypes&:branchIds&:accountIds&:serviceAreaIds' +
        '&:depotIds&:supplyAccountIds&:teamIds&:agentIds&:labels&:tags&:vehicleTypeIds&:riskTypes&:configuredFieldName&:configuredFieldValue&:programTypes' +
        '&:inRoute&:isPacked&:packingStatuses&:timeToDeliver&:approvalStatuses&:dispatchQuoteTypes&:isMissingPackages&:dateRangeTemplateType&:packagesIds&:groupIds&:agentBranchIds&:reasonType&:agentType',
      template: '<deliveries-view from="vm.from" to="vm.to" group="vm.group" service-types="vm.serviceTypes"  configured-field-name="vm.configuredFieldName" configured-field-value="vm.configuredFieldValue" ' +
        'branch-ids="vm.branchIds" approval-statuses="vm.approvalStatuses" account-ids="vm.accountIds" service-area-ids="vm.serviceAreaIds" depot-ids="vm.depotIds" ' +
        'supply-account-ids="vm.supplyAccountIds" team-ids="vm.teamIds" agent-ids="vm.agentIds" labels="vm.labels" tags="vm.tags" vehicle-type-ids="vm.vehicleTypeIds" risk-types="vm.riskTypes" ' +
        'program-types="vm.programTypes" in-route="vm.inRoute" is-packed="vm.isPacked" packing-statuses="vm.packingStatuses" time-to-deliver="vm.timeToDeliver" dispatch-quote-types="vm.dispatchQuoteTypes" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" is-missing-packages="vm.isMissingPackages" date-range-template-type="vm.dateRangeTemplateType"' +
        ' packages-ids="vm.packagesIds" view-table-settings="vm.viewTableSettings" agent-type="vm.agentType" group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" agent-branch-ids="vm.agentBranchIds"' +
        ' reason-type="vm.reasonType"></deliveries-view>',
      controller: function (deliveriesConstants, $scope, $stateParams, splitService, metadataSettings, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            commonsService: CommonsService, quickFilterContextService: QuickFilterContextService, viewFilterSettingsService: ViewFilterSettingsService,
                            dateRangeContextService: DateRangeContextService, $state, $location, groups, site) {

        const deliveriesSettings = splitService.getSiteDeliverySettings(site.id),
          siteProgramTypes = splitService.getSiteProgramTypes();
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        const dateRange = dateRangeContextService.getRange();

        this.from;
        this.to;

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if (!!(deliveriesSettings.daysBefore || deliveriesSettings.daysAfter)) {
          this.from = moment().subtract(deliveriesSettings.daysBefore || 0, 'days').startOf('day').valueOf();
          this.to = moment().add(deliveriesSettings.daysAfter || 0, 'days').endOf('day').valueOf();
        } else if (!!dateRange.from && !!dateRange.to) {
          this.from = dateRange.from;
          this.to = dateRange.to;
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.group = $stateParams.group || deliveriesSettings.defaultGroup || 'Total';
        this.serviceTypes = $stateParams.serviceTypes ? commonsService.parseArrayStateParam($stateParams.serviceTypes) : quickActiveFilter?.settings.serviceTypes;
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds;
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds || viewFilterSettingsService.getAccountIds() || [];
        this.agentBranchIds = commonsService.parseArrayStateParam($stateParams.agentBranchIds) || quickActiveFilter?.settings.agentBranchIds || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.depotIds = commonsService.parseArrayStateParam($stateParams.depotIds) || quickActiveFilter?.settings.depotIds;
        this.supplyAccountIds = commonsService.parseArrayStateParam($stateParams.supplyAccountIds) || quickActiveFilter?.settings.supplyAccountIds;
        this.teamIds = commonsService.parseArrayStateParam($stateParams.teamIds) || quickActiveFilter?.settings.teamIds || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings.agentIds;
        this.labels = commonsService.parseArrayStateParam($stateParams.labels) || quickActiveFilter?.settings.labels;
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || quickActiveFilter?.settings.tags;
        this.vehicleTypeIds = commonsService.parseArrayStateParam($stateParams.vehicleTypeIds) || quickActiveFilter?.settings.vehicleTypeIds;
        this.riskTypes = commonsService.parseArrayStateParam($stateParams.riskTypes) || quickActiveFilter?.settings.riskTypes;
        this.approvalStatuses = commonsService.parseArrayStateParam($stateParams.approvalStatuses) || quickActiveFilter?.settings.approvalStatuses;

        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes) || quickActiveFilter?.settings.programTypes;
        this.dispatchQuoteTypes = commonsService.parseArrayStateParam($stateParams.dispatchQuoteTypes) || quickActiveFilter?.settings.dispatchQuoteTypes;
        this.inRoute = !!$stateParams.inRoute ? JSON.parse($stateParams.inRoute) : quickActiveFilter?.settings.inRoute;
        this.configuredFieldName = !!$stateParams.configuredFieldName ? $stateParams.configuredFieldName : quickActiveFilter?.settings.configuredFieldName;
        this.configuredFieldValue = !!$stateParams.configuredFieldValue ? $stateParams.configuredFieldValue : quickActiveFilter?.settings.configuredFieldValue;
        this.isPacked = !!$stateParams.isPacked ? JSON.parse($stateParams.isPacked) : quickActiveFilter?.settings.isPacked;
        this.packingStatuses = commonsService.parseArrayStateParam($stateParams.packingStatuses) || quickActiveFilter?.settings.packingStatuses;
        this.isMissingPackages = !!$stateParams.isMissingPackages ? JSON.parse($stateParams.isMissingPackages) : quickActiveFilter?.settings.isMissingPackages;
        this.timeToDeliver = $stateParams.timeToDeliver || quickActiveFilter?.settings.timeToDeliver;
        this.packagesIds = commonsService.parseArrayStateParam($stateParams.packagesIds) || quickActiveFilter?.settings.packagesIds;
        this.reasonType = commonsService.parseArrayStateParam($stateParams.reasonType) || quickActiveFilter?.settings.reasonType;
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;

        if (!$stateParams.branchIds && this.branchIds.length) {
          $location.search('branchIds', this.branchIds);
        }

        if (!$stateParams.accountIds && this.accountIds.length) {
          $location.search('accountIds', this.accountIds);
        }

        if (!$stateParams.group && this.group) {
          $location.search('group', this.group);
        }

        if (!$stateParams.serviceAreaIds && this.serviceAreaIds.length) {
          $location.search('serviceAreaIds', this.serviceAreaIds);
        }

      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        },
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        }
      }
    })
    .state(ServicesViewsStateType.DELIVERIES_TABLE_STATE, {
      url: '/table',
      controllerAs: 'vm',
      template: '<deliveries-table-view view-table-settings="vm.viewTableSettings"></deliveries-table-view>',
      controller: function (triBreadcrumbsService, viewTableSettings: ViewSettingsModel[]) {

        const userViewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.User);

        if (userViewTableSettings) {
          this.viewTableSettings = userViewTableSettings
        } else {
          this.viewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Table"});
        triBreadcrumbsService.addCrumb({name: "Services", state: "deliveries.table"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      },
      resolve: {
        viewTableSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser(ServicesViewsStateType.DELIVERIES_TABLE_STATE, ViewSettingsType.ViewTable);
        }
      }
    })
    .state(ServicesViewsStateType.DELIVERIES_MAP_STATE, {
      url: '/map:agentId',
      controllerAs: 'vm',
      template: '<deliveries-map-view is-agent-section-enabled="$ctrl.mapAgentsSectionEnable" ' +
        'deliveries-settings="$ctrl.filterConfig.deliveriesSettings" branch-ids="$ctrl.filterConfig.bringozFilters.branchIds" ' +
        'account-ids="$ctrl.filterConfig.bringozFilters.accountIds" agent-ids="$ctrl.filterConfig.bringozFilters.agentIds" ' +
        'depot-ids="$ctrl.filterConfig.bringozFilters.depotIds" view-table-settings="vm.viewTableSettings" ' +
        'is-agents-panel-open="$ctrl.panelSettings.agents" is-routes-panel-open="$ctrl.panelSettings.routes"></deliveries-map-view>',
      controller: function (triBreadcrumbsService, viewTableSettings: ViewSettingsModel[]) {

        const userViewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.User);
        if (userViewTableSettings) {
          this.viewTableSettings = userViewTableSettings;
        } else {
          this.viewTableSettings = viewTableSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Map"});
        triBreadcrumbsService.addCrumb({name: "Services", state: "deliveries.table"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      },
      resolve: {
        viewTableSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser(ServicesViewsStateType.DELIVERIES_MAP_STATE, ViewSettingsType.ViewTable);
        }
      }
    })

    //*** Service View **//
    .state('service', {
      parent: 'bringoz.site',
      url: '/services/:id',
      abstract: true,
      controllerAs: 'vm',
      template: '<service-view service-id="vm.serviceId"></service-view>',
      controller: function ($stateParams, site) {
        this.serviceId = $stateParams.id;
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    //*** Delivery **//
    .state('service.delivery', {
      url: '/delivery',
      abstract: true,
      views: {
        'mainView': {
          template: '<delivery-detailed-view delivery="$ctrl.service" agent-id="$ctrl.service.agentId" service-areas="vm.serviceAreas"></delivery-detailed-view>',
          controllerAs: 'vm',
          controller: function () {
          },
        }
      }
    })
    .state('service.delivery.info', {
      url: '/info',
      pageTrack: '/delivery/details/info',
      template: '<service-details-info service="$ctrl.delivery" service-meta-data="vm.serviceMetaData" task-meta-data="vm.taskMetaData"></service-details-info>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, splitService, metadataSettings) {

        this.serviceMetaData = splitService.getServicesMetadataSettings();
        this.taskMetaData = splitService.getTasksMetadataSettings();

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Info'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.pricing', {
      url: '/pricing',
      pageTrack: '/delivery/details/pricing',
      template: '<delivery-detailed-view-pricing delivery="$ctrl.delivery" billing="vm.billing"></delivery-detailed-view-pricing>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, billing) {
        this.billing = billing;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Pricing'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      },
      resolve: {
        billing: (deliveriesService, $stateParams, site) => {
          return deliveriesService.getDeliveryBilling($stateParams.id);
        }
      }
    })
    .state('service.delivery.auctions', {
      url: '/auctions',
      pageTrack: '/delivery/details/auctions',
      template: '<auctions-list-view delivery="$ctrl.delivery"></auctions-list-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Auctions'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.history', {
      url: '/history',
      pageTrack: '/delivery/details/history',
      template: '<div layout="column" class="full-height">' +
        '<delivery-history-table flex delivery="$ctrl.delivery" history="$ctrl.delivery.history" ' +
        'selected-action="$ctrl.selectedAction" on-select-action="$ctrl.onSelectAction(action)"></delivery-history-table>' +
        '</div>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'History'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.offline', {
      url: '/offline',
      pageTrack: '/delivery/details/offline',
      template: '<service-offline-actions-view service="$ctrl.delivery"></service-offline-actions-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Offline Actions'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.sms', {
      url: '/sms',
      controllerAs: 'vm',
      pageTrack: '/delivery/details/sms',
      template: '<deliveries-sms-messages-view reference-id="$ctrl.delivery.id"></deliveries-sms-messages-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.timeline', {
      url: '/timeline',
      pageTrack: '/delivery/details/timeline',
      template: '<service-timeline-logs-view service="$ctrl.delivery"></service-timeline-logs-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Timeline'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.delivery.chat', {
      url: '/chat',
      pageTrack: '/delivery/details/chat',
      template: '<chat-conversation-service-view [service-id]="$ctrl.delivery.id"></chat-conversation-service-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Chat'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })

    .state('service.edit-delivery', {
      url: '/edit-delivery',
      pageTrack: '/delivery/edit',
      views: {
        'mainView@service': {
          template: '<delivery-edit-view-state delivery="$ctrl.service" price-plan-bundle="vm.pricePlanBundle" ' +
            'account="vm.account" customers="vm.customers"></delivery-edit-view-state>',
          controllerAs: 'vm',
          controller: function (triBreadcrumbsService, deliveriesService, pricePlanBundle, service, account, customers) {
            this.pricePlanBundle = pricePlanBundle;
            this.account = account;

            const pickup = deliveriesService.getPickups(service)[0],
              dropoff = deliveriesService.getDropoffs(service)[0];

            this.customers = {
              Pickup: _getCustomerByTask(pickup, customers),
              Dropoff: _getCustomerByTask(dropoff, customers)
            };

            function _getCustomerByTask(task, customersList) {
              if ((!customersList || !customersList.length) || (!task || !task.taskSpec.locationDetails)) {
                return undefined;
              }
              return _.find(customersList, (c) => {
                return c.id === _.get(task.taskSpec, 'locationDetails.id');
              });
            }

            // Bread Crumbs
            triBreadcrumbsService.reset();
            triBreadcrumbsService.addCrumb({name: 'Edit'});
            triBreadcrumbsService.addCrumb({
              name: service.id,
              state: 'service.delivery.info',
              params: {id: service.id},
              ignoreTranslate: true
            });
            triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
            triBreadcrumbsService.addCrumb({name: 'Dispatch'});
          }
        }
      },
      resolve: {
        service: ($stateParams, site, servicesFacadeService: ServicesFacadeService) => {
          servicesFacadeService.getOne($stateParams.id);
          return new Promise(resolve => {
            servicesFacadeService.selectOne($stateParams.id).pipe(takeWhile((service: Service) => !service, true))
              .subscribe(
                (service: any) => {
                  if (!!service) {
                    resolve(angular.copy(service));
                  }
                })
          })
        },
        pricePlanBundle: (pricePlanBundleRequestsService: PricePlanBundleRequestsService, service) => {
          return pricePlanBundleRequestsService.getPricePlanBundleByAccountId(service.accountId);
        },
        account: ($account: $accountFactory, service) => {
          return $account(service.accountId).$asyncValue();
        },
        customers: ($customers, service) => {
          const customerIds = _.chain(service.taskList)
            .filter((task: TaskModel) => {
              return _.get(task.taskSpec, 'locationDetails.locationType') === "CUSTOMER"
            })
            .map((filteredTask) => {
              return filteredTask.taskSpec.locationDetails.id;
            })
            .value();

          return $customers().$asyncValues(customerIds);
        }
      }
    })

    //*** Operation **//
    .state('service.operation', {
      url: '/operation',
      abstract: true,
      views: {
        'mainView': {
          template: '<operation-detailed-view operation="$ctrl.service" agent-id="$ctrl.service.agentId" service-areas="vm.serviceAreas"></operation-detailed-view>',
          controllerAs: 'vm',
          controller: function () {
          },
        }
      }
    })
    .state('service.operation.info', {
      url: '/info',
      pageTrack: '/operation/details/info',
      template: '<service-details-info service="$ctrl.operation" service-meta-data="vm.serviceMetaData" task-meta-data="vm.taskMetaData"></service-details-info>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, splitService, metadataSettings) {

        this.serviceMetaData = splitService.getServicesMetadataSettings();
        this.taskMetaData = splitService.getTasksMetadataSettings();

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Info'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.operation.sms', {
      url: '/sms',
      controllerAs: 'vm',
      pageTrack: '/operation/details/sms',
      template: '<deliveries-sms-messages-view reference-id="$ctrl.operation.id"></deliveries-sms-messages-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.operation.timeline', {
      url: '/timeline',
      pageTrack: '/operation/details/timeline',
      template: '<service-timeline-logs-view service="$ctrl.operation"></service-timeline-logs-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Timeline'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.operation.chat', {
      url: '/chat',
      pageTrack: '/operation/details/chat',
      template: '<chat-conversation-service-view [service-id]="$ctrl.operation.id"></chat-conversation-service-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Chat'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.operation.history', {
      url: '/history',
      pageTrack: '/operation/details/history',
      template: '<div layout="column" class="full-height">' +
        '<delivery-history-table flex delivery="$ctrl.operation" history="$ctrl.operation.history" ' +
        'selected-action="$ctrl.selectedAction" on-select-action="$ctrl.onSelectAction(action)"></delivery-history-table>' +
        '</div>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Timeline'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.operation.offline', {
      url: '/offline',
      pageTrack: '/operation/details/offline',
      template: '<service-offline-actions-view service="$ctrl.operation"></service-offline-actions-view>',
      controller: function (triBreadcrumbsService, $stateParams) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Offline Actions'});
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
        triBreadcrumbsService.addCrumb({name: 'Dispatch'});
      }
    })
    .state('service.edit-operation', {
      url: '/edit-operation',
      pageTrack: '/operation/edit',
      views: {
        'mainView@service': {
          template: '<edit-operation account="$ctrl.account" billing-account="vm.billingAccount" ' +
            'price-plan-bundle="vm.pricePlanBundle" order="vm.order" quote="vm.quote"></edit-operation>',
          // template: '<delivery-edit-view-state delivery="$ctrl.service" price-plan-bundle="vm.pricePlanBundle" ' +
          //     'account="vm.account" customers="vm.customers"></delivery-edit-view-state>',
          controllerAs: 'vm',
          controller: function (triBreadcrumbsService, deliveriesService: DeliveriesService, ordersService: OrdersService,
                                pricePlanBundle, service, account, defaultDepot, customers) {
            this.account = account;
            this.billingAccountId = account.billingAccountId;
            this.pricePlanBundle = pricePlanBundle;
            this.order = ordersService.getEmptyOperationOrder(account, defaultDepot, pricePlanBundle, null, service);

            // Bread Crumbs
            triBreadcrumbsService.reset();
            triBreadcrumbsService.addCrumb({name: 'Edit'});
            triBreadcrumbsService.addCrumb({
              name: service.id,
              state: 'service.operation.info',
              params: {id: service.id}
            });
            triBreadcrumbsService.addCrumb({name: 'Services', state: 'deliveries.table'});
            triBreadcrumbsService.addCrumb({name: 'Dispatch'});
          }
        }
      },
      resolve: {
        service: ($stateParams, site, servicesFacadeService: ServicesFacadeService) => {
          servicesFacadeService.getOne($stateParams.id);
          return new Promise(resolve => {
            servicesFacadeService.selectOne($stateParams.id).pipe(takeWhile((service: Service) => !service, true))
              .subscribe(
                (service: any) => {
                  if (!!service) {
                    resolve(angular.copy(service));
                  }
                })
          })
        },
        pricePlanBundle: (pricePlanBundleRequestsService: PricePlanBundleRequestsService, service) => {
          return pricePlanBundleRequestsService.getPricePlanBundleByAccountId(service.accountId);
        },
        account: ($account: $accountFactory, service) => {
          return $account(service.accountId).$asyncValue();
        },
        defaultDepot: function ($stateParams, $depots, account, site) {
          return account.defaultDepotId ? $depots(account.defaultDepotId).$asyncValue() : undefined;
        },
        customers: ($customers, service) => {
          var customerIds = _.chain(service.taskList)
            .filter((task: TaskModel) => {
              return !_.isUndefined(task.taskSpec.customerId);
            })
            .map((filteredTask) => {
              return filteredTask.taskSpec.customerId;
            })
            .value();

          return $customers().$asyncValues(customerIds);
        }
      }
    })

    //*** Upload Deliveries View **//
    .state('deliveries-upload', {
      parent: 'bringoz.site',
      url: '/deliveries-upload',
      controllerAs: 'vm',
      template: '<upload-deliveries-view schema-default-fields="vm.schemaDefaultFields" schemas="vm.schemas"></upload-deliveries-view>',
      controller: function (triBreadcrumbsService, schemaDefaultFields, schemas, site) {

        this.schemaDefaultFields = schemaDefaultFields;
        this.schemas = schemas || [];

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Upload Deliveries"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      },
      resolve: {
        schemaDefaultFields: (site, batchRequestsService: BatchRequestsService) => {
          return batchRequestsService.getSchemaDefaultFields("Service");
        },
        schemas: (site, batchRequestsService: BatchRequestsService) => {
          return batchRequestsService.getSchemas("Service");
        }
      }
    })
    //*** Recurring Services View **//
    .state('recurring-services', {
      parent: 'bringoz.site',
      url: '/recurring-services?:queryString',
      template: '<recurring-services-view branch-ids="vm.branchIds" query-string="vm.queryString"></recurring-services-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, site) {
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || [];
        this.queryString = $stateParams.queryString;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recurring Services'});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      }
    })

    //*** Import Recurring Services View **//
    .state('import-recurring-services', {
      parent: 'bringoz.site',
      url: '/import-recurring-services',
      template: '<import-recurring-services-view></import-recurring-services-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recurring Services'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      }
    })


}
